import { placePT } from "#i18n/translations/pt-BR/place";
import { RequestClosingOfEventOperationResponse } from "#resources/api/enterprise-generated";

type EventType = keyof typeof placePT.financialFile.eventType;
type EventModel = keyof typeof placePT.financialFile.eventModel;
type EventBillingType = keyof typeof placePT.financialFile.invoiceType;

export interface RequestClosingOfEventOperationResponseJSON
	extends RequestClosingOfEventOperationResponse {
	eventType: EventType;
	eventModel: EventModel;
	eventBillingType: EventBillingType;
	financialClosingResponse?: {
		title: string;
		previousValue: number;
		newValue: number;
	}[];
}

/**
 * Type guard to validate the type-safe fields of RequestClosingOfEventOperationResponseJSON
 */
export function isRequestClosingOfEventOperationResponseJSON(
	value: unknown,
): value is RequestClosingOfEventOperationResponseJSON {
	if (!value || typeof value !== "object") {
		return false;
	}

	const data = value as Record<string, unknown>;

	// Check type-safe enum fields
	const validEventTypes = Object.keys(placePT.financialFile.eventType);
	const validEventModels = Object.keys(placePT.financialFile.eventModel);
	const validInvoiceTypes = Object.keys(placePT.financialFile.invoiceType);

	return (
		typeof data.eventType === "string" &&
		validEventTypes.includes(data.eventType) &&
		typeof data.eventModel === "string" &&
		validEventModels.includes(data.eventModel) &&
		typeof data.eventBillingType === "string" &&
		validInvoiceTypes.includes(data.eventBillingType)
	);
}
